<template>
    <div>
     <b-modal size="xl" 
      :modal-class="'is-draggable'"
     :id="ModalId" 
      @shown="prepararDrag"
     :visible="true" centered no-close-on-backdrop no-close-on-esc :title="TitleWindow"
     ref="modalEditSignature" @close="this.emitEventCancel"
      @ok="this.emitEventOK" :ok-title="this.$t('Shared.Save')" 
       @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 

       
      <b-row v-for="(item, index) in this.problemAggregateList" :key="index">
        <span class="InterventionByObjWizard">{{item.name}}</span>
        <b-col lg="12" md="12" sm="12" class="mb-3">
            <MdCheckListBox2 
                v-model="item.model"
                v-bind:Options="item.list"
                v-bind:OnChangeProp="OnChangeBehavioral"
                v-bind:columnCount="2"
                :textField="'name'"
                :valueField="'id'"/>
        </b-col>
    </b-row>   
       
     </b-modal>  
    </div>
</template>
 
 <script>
 //import Utils from '@/common/utils'
 import ShowMessage from '@/components/messages/ShowMessage.js'

 import TreatmentPlanService from '@/services/treatmentplan.service' 

 export default {
   name: 'ModalEditBehavioral',
   mixins: [ShowMessage],  
   props: {
     ModalId: String,
     TitleWindow: String,
     BehavioralsProp:Array,
     ProblemRecId:String,
     probCode:String,
     ItemSelected:Array,
   },
   
   data(){
     return {
        behavioraldescription:"",   
        problemAggregateList:[],    
        ListPsychosocial:[],
        ModalBehavioralsList: [...this.BehavioralsProp]       
     }
   },
 
   methods:{
     prepararDrag() {
  this.$nextTick(() => {
    const outer = document.getElementById(`${this.ModalId}___BV_modal_outer_`);
    if (!outer) {
      console.warn("No se encontró el contenedor del modal");
      return;
    }

    const dialog = outer.querySelector(".modal-dialog");
    const header = outer.querySelector(".modal-header");

    if (!dialog || !header) {
      console.warn("No se encontró header o dialog");
      return;
    }

    if (outer.classList.contains("is-draggable")) 
            return;

    header.style.cursor = "move";

    header.onmousedown = (e) => {
      e.preventDefault();

      // Obtener posición actual antes de tocar estilos
      const rect = dialog.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      // Fijar posición actual (solo en el primer movimiento)
      dialog.style.width = `${rect.width}px`;
      dialog.style.height = `${rect.height}px`;
      dialog.style.position = "fixed";
      dialog.style.left = `${rect.left}px`;
      dialog.style.top = `${rect.top}px`;
      dialog.style.margin = 0;
      dialog.style.transform = "none";

      const moveHandler = (eMove) => {
        dialog.style.left = `${eMove.clientX - offsetX}px`;
        dialog.style.top = `${eMove.clientY - offsetY}px`;
      };

      document.addEventListener("mousemove", moveHandler);
      document.addEventListener(
        "mouseup",
        () => document.removeEventListener("mousemove", moveHandler),
        { once: true }
      );
    };
  });
},
     emitEventOK(/*bvModalEvent*/){
       /*if (this.validateFields()) {
         this.categoryItems.incidentTypes = this.IncidentCodes
         this.setInterventions()
         if (this.ModeEdit == false) {
           this.categoryItems.id = Utils.generateRecID()
         }               
         this.$emit('getCodeConditionOK',this.categoryItems);
       } else {       
         bvModalEvent.preventDefault()
       }    */  
       this.UpdateBehavioral();
     },

     OnChangeBehavioral(){

     },

     getIdList(arr){
      let result = [];
      for(var i = 0; i < arr.length; i++){
        result.push(arr[i].id);
      }
      return result;
     },

     AssignModel(pos,list){
      for(var i = 0; i < list.length; i++){       
        for(var j = 0; j < this.problemAggregateList[pos].list.length; j++){
          if(list[i].name === this.problemAggregateList[pos].list[j].name){
            this.problemAggregateList[pos].model.push(this.problemAggregateList[pos].list[j].id);
          }
        }
      }
     },

     PopulateSelected(){
      if(this.ItemSelected.length > 0){
        for(var i = 0; i < this.ItemSelected.length; i++){
          for(var j = 0; j < this.problemAggregateList.length; j++){            
            if(this.ItemSelected[i].aggName === this.problemAggregateList[j].name){
              this.problemAggregateList[j].probAggrRecId = this.ItemSelected[i].probAggrRecId;
              this.AssignModel(j,this.ItemSelected[i].list);
            }
          }
        }
      }
     },

     getMedTxProblemAggregates() {
            this.$emit('load', true);
            var parameter = {
                ProblemNumber: this.probCode,
                HeaderId: null
            };
            TreatmentPlanService.getMedTxProblemAggregates(parameter)
                .then((response) => {
                if (response.status == '200' && response.data) {
                    this.problemAggregateList = response.data.map(item => ({ ...item, model: [] }));
                    this.PopulateSelected();
                }
                this.$emit('load', false);
            })
                .catch(error => {
                this.$emit('load', false);
                if (!error.response) {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.retrieveInfo'), "error");
                }
                else if (error.response.status === 400) {
                    this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                }
                else if (error.response.status === 500) {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.ThereWereSomeError'), "error");
                }
                else {
                    this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                }
            });
        },


    getList(model,list){
      let result = [];
      for(var i = 0; i < model.length; i++){
        for(var j = 0; j < list.length; j++){
          if(model[i] === list[j].id){
            result.push({id:list[j].id,name:list[j].name});
          }
        }
      }
      return result;
    },


    CreateStructure(){
      for(var i = 0; i < this.problemAggregateList.length; i++){
        let result = this.getList(this.problemAggregateList[i].model,this.problemAggregateList[i].list);
        this.ListPsychosocial.push(
          {
            probAggrRecId: this.problemAggregateList[i].probAggrRecId,
            aggName: this.problemAggregateList[i].name,
            selectionValues: "",
            otherValues: null,
            probRecId: this.ProblemRecId,
            list:result
          }
        )
      }      
    },

     UpdateBehavioral(){        
         this.CreateStructure();        
         let aggregates = {
          aggregates:this.ListPsychosocial
         }
          TreatmentPlanService.UpdateProblemAggregates(this.ProblemRecId,aggregates)
            .then((response) => { 
               if(response.data){
                this.$emit('RefreshGetTP');
                setTimeout(() => 
                        this.$bvToast.toast(this.$t('treatmentplan.BehavioralSaved'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 20); 
               }             
            })
            .catch((error) => {
                if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToUpdate'),"error");
                }     
                   else if(error.response.status === 400 ){
                     this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }   
                     else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }    
            });
       
    },

       
     emitEventCancel(){
       this.$emit('ModalTPEditBehavioralCANCEL');
    },    
   },
 
  mounted(){
    this.getMedTxProblemAggregates();
   },
 };
 </script>

 <style>


.modal-dialog {
  transition: none !important;
  transform: none !important;
}

.modal-dialog.dragging {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  opacity: 0.98;
  cursor: grabbing !important;
  transition: box-shadow 0.2s ease;
}
.modal-header {
  user-select: none; /* evita seleccionar texto al arrastrar */
}
</style>